/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/223-man-woman': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 014 1.5zM13 1.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0113 1.5zM4 4H1a1 1 0 00-1 1v5h1v6h1.25v-6h.5v6H4v-6h1V5a1 1 0 00-1-1zM15.234 8L16 7.445l-2.083-3.221a.5.5 0 00-.417-.225h-4a.497.497 0 00-.417.225L7 7.445 7.766 8l1.729-2.244.601 1.402-2.095 3.841h1.917l.333 5h1v-5h.5v5h1l.333-5h1.917l-2.095-3.842.601-1.402 1.729 2.244z"/>'
  }
})
